import { ButtonBase, Skeleton, Typography } from '@mui/material';
import type { Catalog } from '../../../Models/Catalog';
import { Colors } from '../../../theme';

type CatalogSelectorCollapsedProps = {
  openDialog: () => void;
  catalog?: Catalog;
};

export function CatalogSelectorCollapsed({ openDialog, catalog }: CatalogSelectorCollapsedProps) {
  if (catalog?.organization) {
    return (
      <ButtonBase data-testid='catalog-selector-button'>
        <Typography
          color='white'
          onClick={openDialog}
          sx={{ backgroundColor: '#1D1C43', borderBottom: '1px solid white', p: 1, cursor: 'pointer' }}
        >
          <b style={{ paddingRight: 4 }}>{catalog.organization.toUpperCase()}</b> {catalog.name?.toUpperCase()} /{' '}
          {catalog.taxonomy?.toUpperCase()}
        </Typography>
      </ButtonBase>
    );
  }
  return <Skeleton variant='rectangular' width={200} height={'100%'} sx={{ backgroundColor: Colors.lighterBlue }} />;
}
